var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { Input } from "@mui/joy";
import { useGetCurrenciesQuery } from "@/store/api";
/** <b>Composant d'affichage en mode édition d'un champ de type Currency</b>*/
export default function CurrencyFieldEdit(_a) {
    var fieldName = _a.fieldName, record = _a.record, onUpdate = _a.onUpdate, fieldClassName = _a.fieldClassName, componentClassName = _a.componentClassName, fieldMetadata = _a.fieldMetadata, isOnStudio = _a.isOnStudio, isReport = _a.isReport;
    var dataList = useGetCurrenciesQuery(null).data;
    var currency_id = "currency_id";
    var currencyList = (dataList && dataList.data.currencies) || [];
    var defaultValue = useMemo(function () {
        if (!record) {
            return "";
        }
        return isReport
            ? record.value
            : record[fieldName || ""] || (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default);
    }, [fieldName, record]);
    var _b = useState(""), value = _b[0], setValue = _b[1];
    var _c = useState(""), devise = _c[0], setDevise = _c[1];
    useEffect(function () {
        setValue(defaultValue || "");
    }, [defaultValue]);
    var conversion_rate_of_dollar = function (amount) {
        return record["amount_usdollar"] / amount;
    };
    var onCurrencyHandler = function (event) {
        var _a;
        var newValue = event.target.value;
        var convertAmountToDollar = newValue;
        if (devise.symbol !== "$") {
            convertAmountToDollar = (convertAmountToDollar * conversion_rate_of_dollar(convertAmountToDollar)).toFixed(2);
        }
        record["amount_usdollar"] = convertAmountToDollar;
        onUpdate && onUpdate(record);
        setValue(newValue);
        if (onUpdate) {
            onUpdate((_a = {}, _a[fieldName] = newValue, _a));
        }
    };
    var defaultCurrency = currencyList &&
        currencyList.filter(function (currency) { return currency.id === record[currency_id]; })[0];
    var conversion_rateToDollar = 1.136;
    var onDeviseHandler = function (event) {
        var _a;
        var convertedAmount = currencyList.filter(function (currency) { return currency.id === event.target.value; })[0];
        var newValue = defaultValue * (convertedAmount.conversion_rate || 1);
        if (defaultCurrency.symbol != "$") {
            newValue = defaultValue * conversion_rate_of_dollar(defaultValue);
        }
        newValue = newValue.toFixed(2);
        setDevise(convertedAmount);
        setValue(newValue);
        record[currency_id] = convertedAmount.id;
        //if the seelcted currency is not $ => change to dollar
        var convertAmountToDollar = newValue;
        if (convertedAmount.symbol !== "$") {
            convertAmountToDollar = (convertAmountToDollar * conversion_rate_of_dollar(convertAmountToDollar)).toFixed(2);
        }
        record["amount_usdollar"] = convertAmountToDollar;
        onUpdate && onUpdate(record);
        if (onUpdate) {
            onUpdate((_a = {}, _a[fieldName] = newValue, _a));
        }
    };
    return (_jsx("div", __assign({ className: "flex-1 ".concat(fieldClassName ? fieldClassName : "") }, { children: isOnStudio ? (_jsx(Input, { type: "text", className: "w-full" })) : (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "flex flex-row text-justify items-center" }, { children: [_jsx("label", { children: "Devise:" }), _jsx("select", __assign({ defaultValue: record[currency_id], onChange: onDeviseHandler, className: "w-full h-8 rounded-md border border-[--color-gray-300] p-1 justify-center shadow cursor-pointer" }, { children: currencyList.map(function (list, index) {
                                return list.status === "Active" && (_jsxs("option", __assign({ value: list.id }, { children: [list.name, " : ", list.symbol] }), index));
                            }) }))] })), _jsx("div", __assign({ className: "py-2" }, { children: _jsx(Input, { type: "text", autoFocus: true, value: value, size: "sm", className: "w-full ".concat(componentClassName ? componentClassName : "text-left "), onChange: onCurrencyHandler }) }))] })) })));
}
